import {ModuleVisibility} from './moduleVisibility';

export class Module {
  _id: string;
  createdAt: string;
  name: string;
  visibility: ModuleVisibility[];
  order: number;
  image_url: string;
  tincan_url: string;
  is_exam: boolean;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/model/module.ts